import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { FolderViewWrapper } from "../../../src/taskpane/components/helpers/folderViewWrapper";
import { SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import { RootState } from "../../../src/taskpane/redux";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { logger } from "../../../utilities/logger";
import { GridProps } from "../useContentManagerBody";

export function useMenuItem_Delete(
  selectedItems: any[],
  waitFor: boolean,
  setWaitFor: (waitFor: boolean) => void,
  setShowDeleteDialog: (showDeleteDialog: boolean) => void,
  gridProps: GridProps,
  setGridProps: (newGridProps: GridProps) => void,
  setSelectionCleared: (selectionCleared: boolean) => void,
) {
  const languageStrings = React.useContext(LanguageContext);

  const currentSharepointFolder = useSelector((state: RootState) => state.currentSharepointFolder);
  const siteInfo = useSelector((state: RootState) => state.tenantInfo.sites);
  const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);

  const [menuItem_Delete, setMenuItem_Delete] = React.useState<IContextualMenuItem>();

  React.useEffect(() => {
    if (selectedItems?.length > 0 && !(selectedItems.some(x => x?.EffectiveBasePermissions?.canDeleteListItem === false))) {
      var folderViewWrapper = new FolderViewWrapper(siteInfo, currentDirectory);
      const canViewFolder = folderViewWrapper.canViewFolder();

      if (canViewFolder || selectedItems.every(x => !x.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder))) {
        setMenuItem_Delete(
          {
            key: "delete",
            disabled: waitFor === true,
            text: `${languageStrings.Delete}`,
            iconProps: { iconName: "Delete" },
            onClick: () => {
              setShowDeleteDialog(true);
            }
          }
        )
      } else {
        setMenuItem_Delete(null);
      }
    } else {
      setMenuItem_Delete(null);
    }
  }, [selectedItems, waitFor, currentSharepointFolder, siteInfo, currentDirectory]);

  const deleteSuccess = (successIds: string[]) => {
    setShowDeleteDialog(false);
    filesDeleted(successIds);
  }

  const filesDeleted = async (successIds: string[]) => {
    try {
      setWaitFor(true)
      const newGridProps: GridProps = { ...gridProps };

      const deletedIndexes = [];
      const newRows = [];

      newGridProps.items.forEach((item, index) => {
        const isSelected = item && successIds.find(x => x === item.ID);
        if (isSelected) {
          deletedIndexes.push(index);
        } else {
          newRows.push(item);
        }
      });

      const newGroups = newGridProps.groups.map(group => {
        let startIndexChange = 0;
        let countChange = 0;
        deletedIndexes.forEach(index => {
          if (index >= group.startIndex && index < group.startIndex + group.totalCount) {
            countChange++;
            if (index === group.startIndex) {
              startIndexChange++;
            }
          } else if (index < group.startIndex) {
            startIndexChange--;
          }
        });
        const numIndex = group.name.search(/\d(?!.*\d)/);
        return {
          ...group,
          startIndex: group.startIndex + startIndexChange,
          totalCount: group.totalCount - countChange,
          count: group.count - countChange,
          name: group.name.substring(0, numIndex) + (group.totalCount - countChange) + ")"
        };
      });

      setSelectionCleared(true);
      setGridProps({
        ...newGridProps,
        items: [...newRows],
        groups: newGroups
      });
      setWaitFor(false);
    } catch (error) {
      logger(error, "useMenuItem_Delete.tsx (filesDeleted)");
    }
  }

  return {
    menuItem_Delete,
    deleteSuccess
  }
}